import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight, Phone } from "lucide-react";

export default function HomeFinalCTA() {
  return (
    <section className="relative py-20 lg:py-28 bg-accent overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 right-0 w-96 h-96 bg-white rounded-full translate-x-1/2 -translate-y-1/2" />
        <div className="absolute bottom-0 left-0 w-64 h-64 bg-white rounded-full -translate-x-1/3 translate-y-1/3" />
      </div>
      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-5 leading-tight">
          Ready to Start Your Project?
        </h2>
        <p className="font-body text-white/80 text-lg mb-2 max-w-xl mx-auto">
          Free in-home consultation. No obligation. We'll walk your space, listen to your goals, and give you an honest quote.
        </p>
        <p className="font-body text-white/65 text-sm mb-10">
          MHIC# 05-147079 · Licensed &amp; Insured · Since 2010
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/contact">
            <Button size="lg" className="bg-white text-accent hover:bg-white/90 font-body font-bold text-base px-8 w-full sm:w-auto shadow-lg">
              Request Free Estimate <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </Link>
          <a href="tel:4105989933">
            <Button size="lg" variant="outline" className="border-white/40 text-white hover:bg-white/10 font-body text-base px-8 w-full sm:w-auto">
              <Phone className="w-4 h-4 mr-2" /> (410) 598-9933
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
}